module.exports = __webpack_public_path__ + "img/cnn-cover.06a8d366.png";